import type { Editor, Extension } from '@tiptap/core'
import { Extension as TiptapExtension } from '@tiptap/core'

import { ButtonViewReturn, DynamicMenuItem } from '@/types'

import DynamicConstructsMenuButton from './components/DynamicConstructsMenuButton.vue'

export interface DynamicConstructsOptions {
  button: ({ editor, extension }: { editor: Editor; extension: Extension }) => ButtonViewReturn
}

export const DynamicConstructs = TiptapExtension.create<DynamicConstructsOptions>({
  name: 'dynamicTemplate',

  addOptions() {
    return {
      toolbar: true,
      button: ({ editor }) => {
        const items: DynamicMenuItem[] = [
          {
            type: 'variable',
            title: 'Insert Variable',
            icon: 'Variable',
          },
          {
            type: 'if',
            title: 'Insert If Block',
            icon: 'If',
          },
          {
            type: 'for',
            title: 'Insert For Loop',
            icon: 'For',
          },
          {
            type: 'tableLoop',
            title: 'Insert Table Loop',
            icon: 'Table',
          },
        ]

        return {
          component: DynamicConstructsMenuButton,
          componentProps: {
            editor,
            icon: 'Code2',
            tooltip: 'Insert Dynamic Constructs',
            items,
          },
        }
      },
    }
  },
})
